<template>
  <div id="product-top-bar">
    <div class="content">
      <div class="logo">
        <a href="https://www.kaleidotechnology.com/" target="_blank">
          <img src="/static/img/ktech.svg" alt="Kaleido-tech">
        </a>
      </div>
      <div class="menu">
        <a href="https://www.kaleidotechnology.com/products" target="_blank">
          <span>{{ $t('products')}}</span>
        </a>

        <a href="https://www.kaleidotechnology.com/services" target="_blank">
          <span>{{ $t('services')}}</span>
        </a>

        <a href="https://www.kaleidotechnology.com/digitalization" target="_blank">
          <span>{{ $t('digitalization')}}</span>
        </a>
        
        <router-link to="contact">
          <span>{{ $t('contact')}}</span>
        </router-link>
      </div>
      <router-link to="login" id="client-area">
        <button class="login-button">
          {{ $t('client_area') }}
        </button>
      </router-link>
      <div class="language">
        <span :class="{active: $i18n.locale == 'en'}" @click="changeLanguage('en')">
          EN
        </span>
        |
        <span :class="{active: $i18n.locale == 'es'}" @click="changeLanguage('es')">
          ES
        </span>
      </div>
      <span class="hamburguer" @click="openMenu = true">
        <i class="fa fa-bars fa-2x"></i>
      </span>
      <transition name="slide">
        <div class="hidden-menu" v-if="openMenu" v-click-outside="hideMenu">
          <div class="logo" style="margin-bottom: 1em">
            <a href="https://www.kaleidotechnology.com/" target="_blank">
              <img src="/static/img/ktech.svg" alt="Kaleido-tech">
            </a>
          </div>
          <a href="https://www.kaleidotechnology.com/products" target="_blank">
            <span>{{ $t('products')}}</span>
          </a>

          <a href="https://www.kaleidotechnology.com/services" target="_blank">
            <span>{{ $t('services')}}</span>
          </a>
          <a href="https://www.kaleidotechnology.com/digitalization" target="_blank">
            <span>{{ $t('digitalization')}}</span>
          </a>
          
          <router-link to="contact">
            <span>{{ $t('contact')}}</span>
          </router-link>

          <router-link to="login" >
            <button class="login-button">
              {{ $t('client_area') }}
            </button>
          </router-link>
          <div class="close-button" @click="openMenu = false">
            <i class="fa fa-arrow-right fa-2x" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script >
  export default {
    name: 'product-top-bar',
    data () {
      return {
        openMenu: false
      }
    },
    directives: {
      clickOutside: {
        bind (el, binding, vnode) {
          var event = function (event) {
            // eslint-disable-next-line
            if (!(el == event.target || el.contains(event.target))) {
              vnode.context[binding.expression](event)
            }
          }
          document.body.addEventListener('click', event)
        }
      }
    },
    methods: {
      changeLanguage (lg) {
        localStorage.setItem('lang', lg)
        this.$i18n.locale = lg
        this.lan = lg
      },
      hideMenu () {
        this.openMenu = false
      }
    }
  }
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
#product-top-bar{
  z-index: 99;
  position: absolute;
  width: 100%;
  text-align: center;
  color: white;
  background: rgba($color: $turq, $alpha: .64);
  .content{
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .5em 0;
    max-width: 100%;
  }
  .logo{
    max-width: 15em;
    padding: 0 1em;
    display: inline-block;
    filter:brightness(100);
    img {max-width: 100%;}
  }
  .menu {
    flex: 1;
    color: white;
    font-weight: 900;
    font-size: 1.1em;
    text-align: right;
    text-transform: uppercase;
    span {
      padding: .2em 1em;
      margin: .5em;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
        text-underline-offset: .4em;
      }
    }
    a {
      color:white;
    }
  }
  .login-button{
    background: $lime;
    border: none;
    padding: .5em 1em;
    border-radius: .3em;
    text-transform: uppercase;
    font-family: MuseoSans-900;
    color: #333;
    
  }
  #body.product {
  padding: 0;
  height: 100vh;
  #app-content {
    padding: 0;
  }
}

}
.language {
  text-align: right;
  white-space: nowrap;
    span:hover{
      cursor:pointer;
      font-weight: bold;
    }
    .active {
        font-family: MuseoSans-900;
    }
}
.language, .hamburguer {
  padding: 0 1em;
  cursor: pointer;
}

.hamburguer {
display: none;
}
.hidden-menu {
  background: rgba($color: #000000, $alpha: .8);
  padding: 1em;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  height: 100vh;
  z-index: 2000;
  font-size: 1.3em;
  display: flex;
  flex-direction: column;
  font-family: MuseoSans-900;
  text-transform: uppercase;

  transition: all .3s ease-in-out;
  a {
    color: white;
    margin: .5em 1em;
  }
  .close-button {
    bottom: .5em;
    width: 100%;
    position: absolute;
    cursor: pointer;
  }
}

.slide-enter {
  right: -5em;
  opacity: 0;
}

.slide-leave-active {
  right: -5em;
  opacity: 0;
}

.slide-enter .slide-container,
.slide-leave-active .slide-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media screen and (max-width: 950px) {
  .hamburguer {
    display: inline;
  }
  .menu {
    opacity: 0;
    pointer-events: none;
    height: 0;
    min-width: 0;
  }
  #client-area {
    display: none
    }
}
</style>


// WEBPACK FOOTER //
// src/components/product/ProductTopBar.vue